import { defineComponent, reactive } from "vue";
export default defineComponent({
  name: "albumDesc",
  props: {
    description: {
      type: String,
      default: ""
    }
  },
  setup: function setup() {
    var data = reactive({});
    return {};
  },
  components: {}
});